import { NodeIndexOutlined } from '@ant-design/icons';
import { Button, Tooltip } from 'antd';
import { useMapSlice } from 'app/containers/Map/slice';
import { RouteData } from 'app/containers/Task/slice/types';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';

type Props = {
  thisTransportRoutes: RouteData[];
  gpsVehicleId: number;
  lastCenteredTransportRoute: null | {
    gpsVehicleId: number;
    routeIndex: number;
  };
};

const ZoomOnTransportRoutesButton: React.FC<Props> = ({
  thisTransportRoutes,
  gpsVehicleId,
  lastCenteredTransportRoute,
}) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const mapActions = useMapSlice().actions;

  return (
    <>
      <Tooltip
        placement="leftTop"
        title={
          !thisTransportRoutes.length
            ? t(
                'Transport.NoTransportRoutesByDateFilter',
                'No routes found for the selected date range.',
              )
            : t('Transport.TransportRoutesCount', '{{count}} routes', {
                count: thisTransportRoutes.length,
              })
        }
      >
        <Button
          onClick={() => {
            dispatch(mapActions.setHighlightedRoutesGpsVehicleId(gpsVehicleId));
            let routeToCenterIndex = 0;
            if (
              lastCenteredTransportRoute &&
              lastCenteredTransportRoute?.gpsVehicleId === gpsVehicleId &&
              lastCenteredTransportRoute.routeIndex <
                thisTransportRoutes.length - 1
            ) {
              routeToCenterIndex = lastCenteredTransportRoute.routeIndex + 1;
            }

            const routeToCenter = thisTransportRoutes[routeToCenterIndex];

            if (routeToCenter) {
              lastCenteredTransportRoute = {
                gpsVehicleId,
                routeIndex: routeToCenterIndex,
              };

              dispatch(
                mapActions.setFitCoordArrOnMap([
                  routeToCenter.geometry.coordinates,
                ]),
              );
            }
          }}
          disabled={!thisTransportRoutes.length}
          shape="circle"
          type="dashed"
          icon={<NodeIndexOutlined style={{ color: '#40A9FF' }} />}
        />
      </Tooltip>
    </>
  );
};

export default ZoomOnTransportRoutesButton;
